import { render, staticRenderFns } from "./marketFollow.pug?vue&type=template&id=05fbee4a&lang=pug&"
import script from "./marketFollow.ts?vue&type=script&lang=ts&"
export * from "./marketFollow.ts?vue&type=script&lang=ts&"
import style0 from "./marketFollow.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports